<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="trackingNumbers"
      :expanded.sync="expanded"
      item-key="TrackingNumber"
      show-expand
      class="elevation-1"
      no-data-text="No Item Recieved Yet"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="p-0 elevation-10">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-if="isManagePage">Is Packed?</th>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in item.Items" :key="record.ItemId">
                  <td v-if="isManagePage">
                    <v-checkbox
                      v-if="record.Permitted"
                      v-model="record.Packed"
                      :disabled="!isManagePage || !isStaff || sealed"
                      @change="
                        setPacked({
                          itemId: record.ItemId,
                          packed: record.Packed,
                        })
                      "
                    ></v-checkbox>
                  </td>
                  <td>
                    {{ record.ItemName }}
                  </td>
                  <td>{{ record.ItemQuantity }}</td>
                  <td>{{ record.Description }}</td>
                  <td>
                    <b-badge pill :variant="getPillVariant(record)">{{
                      getStatus(record)
                    }}</b-badge>
                  </td>
                  <td>
                    <v-icon
                      :disabled="sealed"
                      v-if="isManagePage && isStaff && !sealed"
                      small
                      @click="itemToDelete = record;deleteItemConfirmation();">
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </tbody></template
            >
          </v-simple-table>
        </td>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon v-if="isManagePage && isStaff && !sealed" :disabled="sealed" small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:[`item.desc`]="{ item }">
        <ItemSummary
          v-for="record in item.Items"
          :key="record.ItemId"
          :item="record"
        />
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.Items[0].Date) }}
      </template>
      <template v-slot:[`item.packed`]="{ item }">
        <v-checkbox
          :input-value="isFullyPacked(item)"
          v-if="canPackAll(item) && isManagePage"
          v-model="item.packed"
          :disabled="!isManagePage || !isStaff || sealed"
          @change="
            setPacked({
              trackingNumber: item.TrackingNumber,
              courier: item.Courier,
              packed: item.packed,
            })"
        ></v-checkbox>
      </template>
      <template v-slot:footer>
        <div @click.prevent="printItems" v-if="contents.length" class="text-center _hoverPointer col-10 col-sm-4 col-md-3 col-lg-2" style="margin: 0 auto; width: 80%">
          <v-icon>
            mdi-printer
          </v-icon>
          Print packed items
        </div>
      </template>
    </v-data-table>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="deleteItem"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
    <div hidden id="print-table">
      <h3>Packed Items for barrel {{ BarrelId }}</h3>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Tracking Number</th>
              <th class="text-left">Courier</th>
              <th class="text-left">Name</th>
              <th class="text-left">Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in packedItems"
              :key="item.trackingNumber + item.name"
            >
              <td>{{ item.trackingNumber }}</td>
              <td>{{ item.courier }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.quantity }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import { useStore } from "@/store";
import ItemSummary from "@/components/ItemSummary.vue";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import BarrelStatusMixin from "@/mixins/BarrelStatusMixin";
import mixins from "vue-typed-mixins";
import { getProhibitedCategoryLabel } from "@/services/ProhibitedCategoriesService";

export default mixins(ConfirmationModalMixin, SnackbarNotifierMixin, BarrelStatusMixin).extend({
  name: "ItemTable",
  components: { ItemSummary, ConfirmationModal, SnackbarNotifier },
  props: {
    barrelStatus: {
      type: String,
      required: true
    },
    BarrelId: {
      required: true,
      type: String,
    },
    contents: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      expanded: [],
      itemToDelete: null,
      tableHeaders: [
        { text: "Is Packed", value: "packed" },
        {
          text: "Tracking Number",
          value: "TrackingNumber",
        },
        { text: "Contents", value: "desc" },
        { text: "Courier", value: "Courier" },
        { text: "Received Date", value: "date" },
      ],
    };
  },
  methods: {
    deleteItemConfirmation() {
      this.showConfirmationModal({
        title: "Delete Item?",
        message: `Are you sure you want to delete <b><em>${this.itemToDelete.ItemName}</em></b>?`,
      });
    },
    itemNames(record) {
      let names = "";
      record.Items.forEach((element) => {
        if (element.ItemQuantity && element.ItemQuantity > 1)
          names += `${element.ItemName} (x${element.ItemQuantity})`;
        else names += element.ItemName;
      });
      return names;
    },
    canPackAll(record) {
      return record.Items.every((p) => p.Permitted);
    },
    formatDate(date) {
      return dayjs(date).format("D-MMM-YYYY");
    },
    getStatus(record) {
      if (record.Packed && record.Permitted) return "Packed";
      if (!record.Permitted || record.ProhibitReason === "Dutiable") return getProhibitedCategoryLabel(record.ProhibitReason);
      return "Received";
    },
    getPillVariant(record) {
      if (record.Permitted) return "success";
      return "warning";
    },
    async setPacked(payload) {
      try {
        payload.BarrelId = this.BarrelId;
        let result = await ApiService.Instance.markItemPacked(payload);
        if(!result.failed?.length) this.showNotifier({
          message: 'Successfully Updated',
          snackbarType: 'success'
        })
        this.$emit("updated");
      } catch (e) {
        this.showNotifier({
          message: 'Failed To Update',
          snackbarType: 'error'
        })
        error(e);
      }
    },
    async deleteItem() {
      try {
        this.loading = true;
        this.startConfirmationLoading();
        let result = await ApiService.Instance.deleteItem({
          itemId: this.itemToDelete.ItemId,
          logicalBarrelId: this.$props.BarrelId,
        });
        if (result) {
          this.showNotifier({
            message: `Successfully Deleted ${this.itemToDelete.ItemName}`,
            snackbarType: "success",
          });
          this.itemToDelete = null;
          this.$emit("updated");
          this.$data.deleted = true;
        }
        this.stopConfirmationLoading();
        this.loading = false;
      } catch (e) {
        this.showNotifier({
          message: `Failed To Delete ${this.itemToDelete.ItemName}`,
          snackbarType: "error",
        });
        this.loading = false;
        error(e);
      }
    },
    isFullyPacked(record) {
      return record.Items.every((i) => {
        return i.Packed;
      });
    },
    printItems() {
      if(!this.packedItems.length){
        this.showNotifier({
          message: 'No Item Packed Yet',
          snackbarType: 'info'
        });
        return;
      }
      const prtHtml = document.getElementById("print-table").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of document.querySelectorAll(
        'link[rel="stylesheet"], style'
      )) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "width=600,height=800,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body style="padding:20px;max-height=200px;max-width=400px !important;">
    ${prtHtml}
  </body>
</html>`);
      setTimeout(() => {
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      }, 1000);
    },
  },
  computed: {
    sealed(){
      return this.isBarrelSealed(this.barrelStatus);
    },
    isManagePage() {
      return this.$route.name == "Manage";
    },
    isDetailsPage() {
      return this.$route.name == "Details";
    },
    isStaff() {
      const groups = useStore().getters.getGroups;
      return groups.includes("Admin") || groups.includes("Worker");
    },
    trackingNumbers() {
      let temp = this.contents;
      temp.forEach((record) => {
        record.date = this.formatDate(record.Items[0].Date);
        record.packed = this.isFullyPacked(record);
      });
      return temp;
    },
    packedItems() {
      var list = [];
      this.contents.forEach((record) => {
        var trackingNumber = record.TrackingNumber;
        var courier = record.Courier;
        record.Items.forEach((item) => {
          list.push({
            trackingNumber,
            courier,
            name: item.ItemName,
            packed: item.Packed,
            quantity: item.ItemQuantity,
            date: this.formatDate(item.Date),
            category: item.category,
          });
        });
      });
      return list.filter((i) => i.packed);
    },
  },
  beforeMount() {
    if (this.isDetailsPage) {
      this.$delete(this.tableHeaders, 0);
    }
  },
});
</script>

<style>
._hoverPointer:hover{
  cursor: pointer;
}
</style>
